// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ErrorInformationStorage } from '@shared/commons/ErrorInformationStorage';
import { Resources } from '@shared/localizations/Resources';
import { Cursors } from '@shared/commons/Cursors';
import { LinkedSystem } from '../misc/LinkedSystem';
import GridPanelTemplate from '@front/templates/GridPanelTemplate.html';
import { TerceraLinkControlConstants } from '../UtilsClasses/TerceraLinkControlConstants';
import { PanelLocKeys, PanelNames } from '../UtilsClasses/FactoryConstants';
import { DynProperty } from '@shared/commons/DynProperty';
import { TerceraSymbolLookupBaseDataProvider } from '@shared/commons/NoNFixedListCore';
import { GridPanelEdit } from '../elements/GridPanelEdit';
import { ApplicationPanel } from './ApplicationPanel';
import { WorkSpaceManager } from '../WorkSpace/WorkSpaceManager';
export class GridPanel extends ApplicationPanel {
    constructor() {
        super(...arguments);
        this.allCharts = [];
        this.restoresElementsSize = null;
        // #endregion
    }
    getType() {
        return PanelNames.GridPanel;
    }
    oninit() {
        super.oninit();
    }
    oncomplete() {
        const _super = Object.create(null, {
            oncomplete: { get: () => super.oncomplete }
        });
        return __awaiter(this, void 0, void 0, function* () {
            _super.oncomplete.call(this);
            this.deserializeDelayedData();
            this.dataProvider = new TerceraSymbolLookupBaseDataProvider();
            this.onEditCallBack = this.onEditCallBack.bind(this);
            this.onGridPickerClose = this.onGridPickerClose.bind(this);
            this.on('editClick', this.onEditClick);
            this.on('refreshChartClick', this.onRefreshChartClick);
            this.on('onSplitterResize', this.onSplitterResized);
            // TODO. SHIT CODE.
            if (!(yield this.tryRestorePanels())) {
                yield this.UpdateAllCharts(2, 2);
            }
            this.applyTheme();
            this.localize();
        });
    }
    RefindAllCharts() {
        this.allCharts = this.findAllComponents('chartPanel');
        this.allCharts.forEach((chart) => {
            chart.set('parentContainerControl', this);
            WorkSpaceManager.currentWorkspace.addPanelFromContainer(chart);
        });
    }
    TickAsync() {
        this.allCharts.forEach((chart) => {
            chart.TickAsync();
        });
    }
    populate(addPanel) {
        if (!addPanel && WorkSpaceManager.needRestoreWS) {
            this.repopulate();
        }
    }
    repopulate() {
        this.allCharts.forEach((chart) => {
            chart.repopulate();
        });
    }
    updateSettings() {
        this.allCharts.forEach((chart) => {
            chart.updateSettings();
        });
    }
    themeChange() {
        this.allCharts.forEach((chart) => {
            chart.callThemeChange();
        });
    }
    localize() {
        super.localize();
        const headerLocKey = PanelLocKeys[PanelNames.GridPanel];
        void this.set('header', Resources.getResource(headerLocKey));
        this.allCharts.forEach((chart) => {
            chart.localize();
        });
    }
    // #region Xml Settings
    Properties() {
        const properties = super.Properties();
        let gridElementsSize = [];
        if (this.get('forbiddenPanel')) {
            gridElementsSize = this.restoresElementsSize;
        }
        else {
            gridElementsSize = this.findAllComponents('resizeSplitter').map((splitter) => splitter.getElementsSize());
        }
        properties.push(new DynProperty('GridElementsSize', gridElementsSize, DynProperty.UNKNOWN, DynProperty.HIDDEN_GROUP));
        return properties;
    }
    callBack(newProperties) {
        super.callBack(newProperties);
        this.restoresElementsSize = DynProperty.getPropValue(newProperties, 'GridElementsSize');
    }
    setSize(w, h) {
        super.setSize(w, h);
        this.layoutTables();
    }
    // TODO. SHIT CODE.
    tryRestorePanels() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const restoreData = this.restoreData;
                delete this.restoreData;
                if (isNullOrUndefined(restoreData))
                    return false;
                const panelType = restoreData.panelType;
                if (isNullOrUndefined(panelType))
                    return false;
                const rows = restoreData.rows;
                const columns = restoreData.columns;
                yield this.UpdateAllCharts(rows, columns);
                void this.set({ panelType });
                if (isValidArray(this.restoresElementsSize)) {
                    const gridSplitters = this.findAllComponents('resizeSplitter');
                    for (let i = 0; i < gridSplitters.length; i++) {
                        const elementsSize = this.restoresElementsSize[i];
                        gridSplitters[i].setElementsSize(elementsSize.prevSize, elementsSize.nextSize);
                    }
                }
                return true;
            }
            catch (ex) {
                ErrorInformationStorage.GetException(ex);
                console.log(ex);
            }
            return false;
        });
    }
    // #endregion
    // #region Symbol/Account Link In
    symbolLink_In(symbolName) {
        const curLinkColor = LinkedSystem.currentLinkOutColor;
        for (let i = 0; i < this.allCharts.length; i++) {
            const chart = this.allCharts[i];
            const panelColor = chart.get('symbolLinkValue');
            if (panelColor !== curLinkColor && panelColor !== TerceraLinkControlConstants.ColorConstants.ALL) {
                continue;
            }
            chart.symbolLink_In(symbolName);
        }
    }
    accountLink_In(accId, fromLinkedSystem) {
        if (fromLinkedSystem && !this.OnAccountLinking()) {
            return false;
        }
        if (this.allCharts == null) {
            return false;
        }
        for (let i = 0; i < this.allCharts.length; i++) {
            const chart = this.allCharts[i];
            chart.accountLink_In(accId);
        }
        return true;
    }
    updateAccountLinkVisible(visible) {
        super.updateAccountLinkVisible(visible);
        this.allCharts.forEach((chart) => {
            chart.updateAccountLinkVisible(visible);
        });
    }
    // #endregion
    getClientPanel() {
        return this.find('.grid-panel-container');
    }
    // #region Layout
    layoutTables() {
        this.allCharts.forEach((chart) => {
            chart.layoutTable();
        });
    }
    onSplitterResized() {
        this.layoutTables();
    }
    setInstruments() {
        const instrumentArray = this.get('instrumentArray');
        if (!isValidArray(instrumentArray)) {
            return;
        }
        for (let i = 0; i < this.allCharts.length; i++) {
            const instrument = instrumentArray[i];
            if (isNullOrUndefined(instrument))
                return;
            this.allCharts[i].symbolLink_In(instrument.GetInteriorID());
        }
    }
    setDefaultRowsLayout() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.set({ standardHeight: 100 });
            yield this.set({ standardWidth: 100 });
            yield this.set({ standardHeight: 100 / this.get('rows') });
            yield this.set({ standardWidth: 100 / this.get('columns') });
            this.layoutTables();
        });
    }
    onRefreshChartClick() {
        this.allCharts.forEach((panel) => {
            const terceraChartRactive = panel.terceraChartRactive;
            const chart = terceraChartRactive ? terceraChartRactive.terceraChart : null;
            if (!isNullOrUndefined(chart)) {
                chart.RefreshChart();
            }
        });
    }
    onEditClick(context) {
        const button = context.component;
        this.set('isGridPickerOpened', true);
        GridPanelEdit.show(button.getX(), button.getY() + 32 + 1, {
            rows: this.get('rows'),
            columns: this.get('columns')
        }, this.onEditCallBack, this.onGridPickerClose);
    }
    instrumentsDropDownCallback(instrumentArray) {
        void this.set('instrumentArray', instrumentArray);
        this.setInstruments();
    }
    onEditCallBack(data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (isValidNumber(data.rows) && isValidNumber(data.columns)) {
                yield this.repopulatePanels(data.rows, data.columns);
            }
            else if (data.resetLayout) {
                yield this.setDefaultRowsLayout();
            }
        });
    }
    onGridPickerClose() {
        this.set('isGridPickerOpened', false);
    }
    repopulatePanels(rows, columns) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteAllCharts();
            yield this.UpdateAllCharts(rows, columns);
        });
    }
    UpdateAllCharts(rows, columns) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.set({
                standardHeight: 100 / rows,
                standardWidth: 100 / columns,
                rows,
                columns
            });
            this.RefindAllCharts();
        });
    }
    RowNumbers() {
        return Array.from({ length: this.get('rows') }, (_, i) => i);
    }
    ColumnNumbers() {
        return Array.from({ length: this.get('columns') }, (_, i) => i);
    }
    updatePanelHeader() { }
    deleteAllCharts() {
        return __awaiter(this, void 0, void 0, function* () {
            this.allCharts.forEach((chart) => {
                WorkSpaceManager.currentWorkspace.removePanelFromContainer(chart);
                chart.dispose();
            });
            yield this.set({ rows: 0, columns: 0 });
            this.allCharts = [];
        });
    }
    dispose() {
        const _super = Object.create(null, {
            dispose: { get: () => super.dispose }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteAllCharts();
            _super.dispose.call(this);
        });
    }
    // #region ISerializable
    serialize() {
        const serializedData = super.serialize();
        serializedData.panelType = this.get('panelType');
        serializedData.rows = this.get('rows');
        serializedData.columns = this.get('columns');
        serializedData.serializedPanelsDict = {};
        if (this.get('forbiddenPanel')) {
            const oldSettings = this.get('chartSerializedSettingsDict');
            const panelNames = Object.keys(oldSettings);
            for (const name of panelNames) {
                serializedData.serializedPanelsDict[name] = oldSettings[name].settings;
            }
        }
        else {
            this.allCharts.forEach((chart) => {
                const panelName = chart.get('name');
                serializedData.serializedPanelsDict[panelName] = chart.serialize();
            });
        }
        return serializedData;
    }
    deserialize(serialized) {
        super.deserialize(serialized);
        if (!this.completed) {
            return;
        }
        this.restoreData = serialized;
        const chartSerializedSettingsDict = {};
        const panelNames = Object.keys(serialized.serializedPanelsDict);
        for (const name of panelNames) {
            chartSerializedSettingsDict[name] = {
                isOldScheme: false,
                settings: serialized.serializedPanelsDict[name]
            };
        }
        void this.set({ chartSerializedSettingsDict });
    }
    deserializeOldScheme(serialized) {
        if (isNullOrUndefined(serialized)) {
            return;
        }
        super.deserializeOldScheme(serialized);
        if (!this.completed) {
            return;
        }
        this.restoreData = serialized.xmlSettingsTemplate;
        const chartSerializedSettingsDict = {};
        const panelNames = Object.keys(serialized.xmlSettingsTemplate.serializedPanelPropertiesDict);
        for (const name of panelNames) {
            chartSerializedSettingsDict[name] = {
                isOldScheme: true,
                settings: {
                    properties: serialized.xmlSettingsTemplate.serializedPanelPropertiesDict[name],
                    xmlSettingsTemplate: serialized.xmlSettingsTemplate.xmlSettingsTemplateDict[name]
                }
            };
        }
        void this.set({ chartSerializedSettingsDict });
    }
}
ApplicationPanel.extendWith(GridPanel, {
    partials: { bodyPartial: GridPanelTemplate },
    data: function () {
        return {
            symbolLinkValue: TerceraLinkControlConstants.STATE_ALL,
            accountLinkValue: TerceraLinkControlConstants.STATE_ALL,
            panelTypeEnum: PanelNames,
            panelType: PanelNames.ChartPanel,
            rows: 0,
            columns: 0,
            instrumentArray: [],
            cursor: Cursors.Default,
            standardHeight: 100,
            standardWidth: 100,
            chartSerializedSettingsDict: {},
            isGridPickerOpened: false
        };
    }
});
